import axios from 'axios';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { initialize } from 'redux-form';
import { getLista as getListaCliente } from '../cliente/clienteActions';

const API = `${consts.API_URL}/clienteArea`;

export const CLIENTE_AREA_MODO_TELA = 'CLIENTE_AREA_MODO_TELA';
export const CLIENTE_AREA_SET_AGUARDANDO = 'CLIENTE_AREA_SET_AGUARDANDO';
export const CLIENTE_AREA_LISTADO = 'CLIENTE_AREA_LISTADO';

const normalizarNumero = valor => {
    if (valor === null || valor === undefined || valor === '') {
        return null;
    }

    if (typeof valor === 'number') {
        return valor;
    }

    return Number(
        valor
            .toString()
            .replace(/\./g, '')
            .replace(',', '.')
    );
};

const normalizarRegistro = registro => ({
    ...registro,
    area_propria: normalizarNumero(registro.area_propria),
    area_arrendada: normalizarNumero(registro.area_arrendada),
    contatos: registro.contatos || []
});

const prepararFormulario = registro => ({
    ...registro,
    contatos: registro.contatos && registro.contatos.length
        ? registro.contatos
        : [
            {
                id: null,
                nome: '',
                celular: '',
                email: ''
            }
        ]
});

export function setModoTela(modo, registro = {}) {
    return {
        type: CLIENTE_AREA_MODO_TELA,
        payload: {
            modo,
            registro
        }
    };
}

export function setAguardando(aguardando) {
    return {
        type: CLIENTE_AREA_SET_AGUARDANDO,
        payload: aguardando
    };
}

export function initForm(registro = {}) {
    return [
        initialize('clienteAreaForm', prepararFormulario(registro))
    ];
}

export function getLista(id_cliente) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const resp = await axios.get(API, {
                params: {
                    id_cliente
                }
            });

            dispatch({
                type: CLIENTE_AREA_LISTADO,
                payload: resp
            });

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            const registroNormalizado = normalizarRegistro(registro);

            const request = registroNormalizado.id
                ? axios.put(API, registroNormalizado)
                : axios.post(API, registroNormalizado);

            await request;

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista(registroNormalizado.id_cliente));
            dispatch(getListaCliente());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess('Operação realizada com sucesso.');

            dispatch(getLista(registro.id_cliente));
            dispatch(getListaCliente());
            dispatch(setModoTela('lista'));

        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
